export const LOGTYPE = {
  INFO: 'Informazione',
  ERROR: 'Errore'
};

export const LOGSEVERITY = {
  NONE: 'Nessuna',
  HIGHT: 'Elevata',
  SEVERE: 'Grave',
  CRITICAL: 'Bloccante'
};
export const PERMISSION = {
  ACCESS_TO_DASHBOARD: 'accedere alla dashboard',
  VIEW_LOGS: 'visualizzare eventi',
  USER_CANCELLATION: 'cancellazione massiva utenti',
  USER_ADDITION: 'associazione massiva utenti',
  NOTIFY_PASSWORD_CHANGE: 'forza aggiornamento password',
  INACTIVE_USER_CANCELLATION: 'cancellazione utenti inattivi',
  USER_DUPLICATED: 'visualizzare utenti duplicati',
  REVIEWS: 'visualizzare recensioni',
  EXACT_ASSOCIATION: 'associazione puntuale',
  SEARCH_IRENYOU: 'ricerca utente irenyou',
  USER_EXTRACTION: 'estrazione utenti irenyou',
  SEARCH_ASSOCIATION: 'associazione irenyou',
  PRIVACY_TC: 'informativa privacy',
  AGING_FATTURE: 'aging fatture',
  RICERCA_UTENTI_FB: 'ricerca utenti facebook'
};

export const WS02_CANCELLATION_RESULT = {
  UTENTE_WSO2_CANCELLATO: 'UTENTE WSO2 CANCELLATO',
  GENERIC_ERROR_WSO2: 'GENERIC ERROR WSO2'
};
export const WS02_CANCELLATION_ESITO = {
  KO: 'KO',
  OK: 'OK',
  WAITING: 'WAITING'
};
export const ASSOCIAZIONE_MASSIVA_DESCRIZIONE_ESITO = {
  // Todo: farsi dare i possibili esiti del batch.
  WAITING: 'In attesa di elaborazione'
};
export const ASSOCIAZIONE_MASSIVA_CODICE_ESITO = {
  KO: 'KO',
  OK: 'OK',
  WAITING: 'WAITING'
};
export const SETTING_CSV = {
  NO_OF_ROWS: 1000,
  EXTENSION: 'csv'
};

export const REGEX_VALIDATE_PASSWORD = /^(?=^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!"@.&*$£€-])|(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[#?!"@.&*$£€-])|(?=.*[a-z])(?=.*\d)(?=.*[#?!"@.&*$£€-])|(?=.*[A-Z])(?=.*\d)(?=.*[#?!"@.&*$£€-]))).{12,}$/;
export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/;
